import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { getReceivers, setReceivers } from "services/Receiver/actions";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { getReceiversRequest } from "./api";
import { receiverSelector } from "./selectors";

const receiversSchema = new schema.Entity("receivers", {}, { idAttribute: "code" });
const receiversListSchema = new schema.Array(receiversSchema);

export function* getReceiverWorker() {
    try {
        const { codes } = yield select(receiverSelector);
        if(!codes.length){
            yield put(setReceivers({ isLoadingReceivers: true }));
            const { receivers } = yield call(getReceiversRequest);
            const { result, entities } = normalize(receivers, receiversListSchema);
            yield put(setReceivers({
                isLoadingReceivers: false,
                receivers: entities.receivers,
                codes: result
            }));
        }
    } catch (error) {
        yield put(setReceivers({ isLoadingReceivers: false }));
        showError(error);
    }
}

export function* getReceiver() {
    yield all([
        yield takeLatest(getReceivers, getReceiverWorker)
    ]);
}
